var ProductReviews, extractReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.Views.ReviewList = require('../views/product_reviews_review_list');

ProductReviews.Model = require('../models/product_review');

if (window.moment == null) {
  window.moment = require('../../../../node_modules/moment/moment.js');
}

extractReviews = require('../../common/helpers').extractReviews;

ProductReviews.Collection = Backbone.Collection.extend({
  defaultTimeout: 3000,
  model: ProductReviews.Model,
  page: 1,
  locale: 'en_US',
  showParams: '',
  sortBy: 'most_recent',
  initialize: function(models, options1) {
    this.options = options1;
    _.extend(this, this.options);
    _.bindAll(this, 'paginationSuccess', 'paginationError');
    if (this.displayOptions.sortBy) {
      return this.sortBy = this.displayOptions.sortBy;
    }
  },
  _prepareModel: function(model, options) {
    _.extend(options, this.options);
    delete options.parse;
    return Backbone.Collection.prototype._prepareModel.call(this, model, options);
  },
  url: function() {
    return this.rootUrl + "/product_review_proxy/reviews.json?deal_uuid=" + this.dealUuid + "&locale=" + this.locale + "&sort=" + this.sortBy + "&limit=" + (this.limit()) + "&offset=" + (this.offset()) + "&show=" + this.showParams;
  },
  sync: function(method, collection, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.timeout || this.defaultTimeout;
    return Backbone.Collection.prototype.sync.call(this, method, collection, options);
  },
  limit: function() {
    return this.pageSize;
  },
  offset: function() {
    return (this.page - 1) * this.pageSize;
  },
  parse: function(response) {
    var i, len, ref, review, user;
    if (!response.reviewable) {
      return;
    }
    if (this.displayOptions.isTouch && (user = response.user)) {
      this.displayOptions.userUpvotedReviews = user.upvotes || [];
      this.displayOptions.userDownvotedReviews = user.downvotes || [];
    }
    if (this.displayOptions.showReviewsPage && this.isPreview) {
      ref = response.reviews || [];
      for (i = 0, len = ref.length; i < len; i++) {
        review = ref[i];
        review.isPreviewReview = true;
      }
    }
    return extractReviews(response, this.displayOptions, I18n, moment);
  },
  initializePreview: function(view) {
    this.view = view;
    if (!this.displayOptions.showReviewsPage) {
      return;
    }
    this.pageSize = this.displayOptions.productReviewsPreview.pageSize;
    return this.action = 'preview';
  },
  nextPage: function(sortOrder) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page++;
    if (sortOrder) {
      this.sortBy = sortOrder;
    }
    this.action = 'nextPage';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError,
      remove: false,
      syncForPagination: true
    });
  },
  getPage: function(page) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page = page;
    this.action = 'getPage';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError
    });
  },
  resortReviews: function(sortOrder) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page = 1;
    if (sortOrder) {
      this.sortBy = sortOrder;
    }
    this.action = 'resortReviews';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError,
      reset: true
    });
  },
  paginationSuccess: function(response) {
    return this.view.render(new ProductReviews.Views.ReviewList({
      collection: this
    }));
  },
  paginationError: function(response) {
    this.page = this.previousPage;
    this.sortBy = this.previousSortBy;
    return this.view.showPaginationError(this.action);
  },
  recordUpvote: function(id) {
    return this.displayOptions.userUpvotedReviews.push(id);
  },
  recordUnvote: function(id) {
    this.displayOptions.userUpvotedReviews = _.without(this.displayOptions.userUpvotedReviews, id);
    return this.displayOptions.userDownvotedReviews = _.without(this.displayOptions.userDownvotedReviews, id);
  },
  recordDownvote: function(id) {
    return this.displayOptions.userDownvotedReviews.push(id);
  },
  fetchedReviews: function() {
    if (this.displayOptions.showReviewsPage) {
      return this.models;
    }
    return this.models.slice(this.offset());
  },
  updateReadMore: function(resetHeight) {
    return this.invoke('updateReadMore', resetHeight);
  }
});

module.exports = ProductReviews.Collection;

//# sourceMappingURL=data:application/json;base64,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
